import script from "./Organizations.vue?vue&type=script&setup=true&lang=ts"
export * from "./Organizations.vue?vue&type=script&setup=true&lang=ts"

import "./Organizations.vue?vue&type=style&index=0&id=7180244c&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7180244c"]])

export default __exports__